/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PopulationLEData
 */
export interface PopulationLEData {
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    age?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    mSbest?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    mPopmed?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    mBottom?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    fSbest?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    fPopmed?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulationLEData
     */
    fBottom?: number;
}

export function PopulationLEDataFromJSON(json: any): PopulationLEData {
    return PopulationLEDataFromJSONTyped(json, false);
}

export function PopulationLEDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopulationLEData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'age': !exists(json, 'age') ? undefined : json['age'],
        'mSbest': !exists(json, 'm_sbest') ? undefined : json['m_sbest'],
        'mPopmed': !exists(json, 'm_popmed') ? undefined : json['m_popmed'],
        'mBottom': !exists(json, 'm_bottom') ? undefined : json['m_bottom'],
        'fSbest': !exists(json, 'f_sbest') ? undefined : json['f_sbest'],
        'fPopmed': !exists(json, 'f_popmed') ? undefined : json['f_popmed'],
        'fBottom': !exists(json, 'f_bottom') ? undefined : json['f_bottom'],
    };
}

export function PopulationLEDataToJSON(value?: PopulationLEData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'age': value.age,
        'm_sbest': value.mSbest,
        'm_popmed': value.mPopmed,
        'm_bottom': value.mBottom,
        'f_sbest': value.fSbest,
        'f_popmed': value.fPopmed,
        'f_bottom': value.fBottom,
    };
}


